export default "__VITE_ASSET__BGh3OzlX__"